import Widget from "components/Widget";
import Element from "components/Element";

import PageViews from "components/Graphs/MixedGraphs/PageViews/PageViews";

import LinesChart from "components/LineCharts/LinesChart";
import LinesChartTime from "components/LineCharts/LinesChartTime";

//Donations
import DonationsBarChart from "components/Donations/DonationsBarChart";
import DonationsBySource from "components/Donations/DonationsBySource";
import DonationsByLongetivity from "components/Donations/DonationsByLongetivity";
import DonationsSummary from "components/Donations/DonationsSummary";
import DonationsVisits from "components/Donations/DonationsVisits";
import DonationsBarLineChart from "components/Donations/DonationsBarLineChart";
import DonationsLineChart from "components/Donations/DonationsLineChart";
import DonationsTableSource from "components/Donations/DonationsTableSource";

// Query Builder
import QueryBuilder from "pages/QueryBuilder";

// ML
import InsightArchive from "components/InsightsArchive/InsightArchive";
import InsightsArchiveList from "components/InsightsArchive/InsightsArchiveList";
import KeyFindings from "./InsightsArchive/KeyFindings";

// Shared
import PageHeader from "components/Elements/PageHeader";
import PageDivider from "components/Elements/PageDivider";

// BritBox
import SummaryFreeTrials from "components/BritBox/SummaryFreeTrials";
import SummaryPaidSubs from "components/BritBox/SummaryPaidSubs";
import Views from "components/BritBox/Views";
import Financial from "components/BritBox/Financial";

import SubscribersSummary from "components/BritBox/SubscribersSummary";
import FreeTrialConversion from "components/BritBox/FreeTrialConversion";
import FreeTrialConversionPrediction from "components/BritBox/FreeTrialConversionPrediction";
import SubscriberRenewalCancel from "components/BritBox/SubscriberRenewalCancel";

import FreeTrialStarts from "components/BritBox/FreeTrialStarts";
import DailyActives from "components/BritBox/DailyActives";
import DailyActivesLive from "components/BritBox/DailyActivesLive";
import DailyActivesLiveYourBiz from "components/BritBox/DailyActivesLiveYourBiz";
import SubscriberMakeup from "components/BritBox/SubscriberMakeup";
import PieChartLegends from "components/BritBox/PieChartLegends";

import WatchingSummary from "components/BritBox/WatchingSummary";
import WatchingSummaryLive from "components/BritBox/WatchingSummaryLive";
import LastWeekSummary from "components/BritBox/LastWeekSummary";
import LastWeekViewing from "components/BritBox/LastWeekViewing";

import NewSubsByPlatform from "components/BritBox/NewSubsByPlatform";
import TopLTVCPA from "components/BritBox/TopLTVCPA";

// import AuditSummary from "components/BritBox/AuditSummary";
// import Audit from "components/BritBox/Audit"
import TopContentSeasonEpisode from "components/BritBox/TopContentSeasonEpisode";
import AuditSummary from "components/BritBox/AuditOverview";
import AuditBoard from "components/BritBox/AuditBoardRoku";
import SeasonViewingCompletion from "components/BritBox/SeasonViewingCompletion";

import AttributionSummary from "components/BritBox/AttributionSummary";
import AttributionEfficiency from "components/BritBox/AttributionEfficiency";

// Marvel
import BarChartLegendsStacked from "components/BarChartLegendsStacked/BarChartLegendsStacked";
import BarChartLegendsStackedNewFollowers from "components/BarChartLegendsStacked/BarChartLegendsStackedNewFollowers";
import BarChartLegendsStackedBoardReport from "components/BarChartLegendsStacked/BarChartLegendsStackedBoardReport";
import BarChartLegendsStackedYourBiz from "components/BarChartLegendsStacked/BarChartLegendsStackedYourBiz";
import BarChartLegends from "components/BarChartLegends/BarChartLegends";
import BarChartLegendsMetric from "components/BarChartLegends/BarChartLegendsMetric";

// AdBoard
import AdsSummary from "components/AdBoard/AdsSummary";
import AdsCostSummary from "components/AdBoard/AdsCostSummary";
import AdsCoreMetrics from "components/AdBoard/AdsCoreMetrics";
import AdsFunnelByNetwork from "components/AdBoard/AdsFunnelByNetwork";
import AdsPlatforms from "components/AdBoard/AdsPlatforms";
import AdsTableCreatives from "components/AdBoard/AdsTableCreatives";

import AdsDataByNetwork from "components/AdBoard/AdsDataByNetwork";
import AdsDataByMonth from "components/AdBoard/AdsDataByMonth";

import CostBudget from "components/AdBoard/CostBudget";
import AdCampaign from "components/AdBoard/AdCampaign";

// Summary Pages
import ViewsYesterday from "components/Metrics/ViewsYesterday/ViewsYesterday";
import MinutesWatchedYesterday from "components/Metrics/MinutesWatchedYesterday/MinutesWatchedYesterday";
import SummaryChannel from "components/Summary/SummaryChannel";
import SummaryChannelByTypeBreakouts from "components/Summary/SummaryChannelByTypeBreakouts";

import PostsSummary from "components/Metrics/PostsSummary/PostsSummary";
import VideoSummary from "components/Metrics/VideoSummary/VideoSummary";
import SocialSummary from "components/SocialBoards/SocialSummary";

import ViewsYesterdayDreamworks from "components/Metrics/ViewsYesterday/ViewsYesterdayDreamworks";
import MinutesWatchedYesterdayDreamworks from "components/Metrics/MinutesWatchedYesterday/MinutesWatchedYesterdayDreamworks";

import MostWatched from "components/Tables/MostWatched/MostWatched";
import MostShared from "components/Tables/MostShared/MostShared";
import SocialTopPosts from "components/SocialBoards/SocialTopPosts";
import SeasonReleasePopularity from "components/Tables/SeasonReleasePopularity/SeasonReleasePopularity";
import Top5Posts from "components/Tables/Top5Posts/Top5Posts";
import Top5PostsPer1000 from "components/Tables/Top5PostsPer1000/Top5PostsPer1000";

import VideoIntelligence from "components/Tables/VideoIntelligence/VideoIntelligence";
import ViewsComparison from "components/Graphs/LineGraphs/ViewsComparison/ViewsComparison";

import YouTube from "components/Graphs/MixedGraphs/YouTube/YouTube";
import SnapChat from "components/Graphs/MixedGraphs/SnapChat/SnapChat";
import Facebook from "components/Graphs/MixedGraphs/Facebook/Facebook";
import Instagram from "components/Graphs/MixedGraphs/Instagram/Instagram";
import Twitter from "components/Graphs/MixedGraphs/Twitter/Twitter";

import ContentVelocity from "components/Graphs/MixedGraphs/ContentVelocity/ContentVelocity";

import SocialFollowersSubscribers from "components/Graphs/MixedGraphs/SocialFollowersSubscribers/SocialFollowersSubscribers";
import FollowersSubscribersBreakdown from "components/Graphs/MixedGraphs/FollowersSubscribersBreakdown/FollowersSubscribersBreakdown";

import VideoViewsByNetwork from "components/Graphs/LineGraphs/VideoViewsByNetwork/VideoViewsByNetwork";
import Visitors from "components/Metrics/Visitors/Visitors";
import VisitorsByMonth from "components/Graphs/BarCharts/VisitorsByMonth/VisitorsByMonth";

import Heatmap from "components/Graphs/Heatmaps/Heatmap";

import PageEngagement from "components/Metrics/PageEngagement/PageEngagement";
import WhereTheyViewed from "components/Graphs/PieCharts/WhereTheyViewed/WhereTheyViewed";

import SocialGoalsFacebookTwitter from "components/Graphs/MixedGraphs/SocialGoalsFacebookTwitter/SocialGoalsFacebookTwitter";
import SocialGoalsInstagramYouTube from "components/Graphs/MixedGraphs/SocialGoalsInstagramYouTube/SocialGoalsInstagramYouTube";
import SocialGoalsInstagramVimeo from "components/Graphs/MixedGraphs/SocialGoalsInstagramVimeo/SocialGoalsInstagramVimeo";
import SocialGoalsInstagramVimeoYouTube from "components/Graphs/MixedGraphs/SocialGoalsInstagramVimeoYouTube/SocialGoalsInstagramVimeoYouTube";
import SocialGoalsFacebookTwitterInstagram from "components/Graphs/MixedGraphs/SocialGoalsFacebookTwitterInstagram/SocialGoalsFacebookTwitterInstagram";
import SocialCountsByBrand from "components/Tables/SocialCountsByBrand/SocialCountsByBrand";

import BillingSummary from "components/BillingBoard/BillingSummary";

import VisitsBySource from "components/Graphs/StackedBarCharts/VisitsBySource/VisitsBySource";
import TopReferrers from "components/Tables/TopReferrers/TopReferrers";

import TopPostsThisHour from "components/Tables/TopPostsThisHour/TopPostsThisHour";
import TopPostsToday from "components/Tables/TopPostsToday/TopPostsToday";
import ViewersLineGraphs from "components/ViewersLineGraphs/ViewersLineGraphs";

import NewReturning from "components/Graphs/NewReturning/NewReturning";
import ReturnFrequency from "components/Graphs/BarCharts/ReturnFrequency/ReturnFrequency";
import Donations from "components/Metrics/Donations/Donations";
import ConversionFunnel from "components/Graphs/BarCharts/ConversionFunnel/ConversionFunnel";

import EmailSummary from "components/Graphs/MixedGraphs/EmailSummary/EmailSummary";

import EmailPerformance from "components/Graphs/LineGraphs/EmailPerformance/EmailPerformance";

import NewsletterRecent from "components/Tables/NewsletterRecent/NewsletterRecent";
import NewslettersTopLinks from "components/Tables/NewslettersTopLinks/NewslettersTopLinks";
import FollowersByBrand from "components/FollowersByBrand/FollowersByBrand";

// Content Page
import ContentTopPages from "components/Tables/ContentTopPages/ContentTopPages";
import TopContent from "components/Tables/TopContent/TopContent";
import TopMovies from "components/Tables/TopMovies/TopMovies";
import Top20Content from "components/Tables/Top20Content/Top20Content";

// Content Videos Social
import ContentYouTubeVideoViews from "components/Tables/ContentYouTubeVideoViews/ContentYouTubeVideoViews";
import ContentVimeoVideoViews from "components/Tables/ContentVimeoVideoViews/ContentVimeoVideoViews";
import ContentParsleyVideoViews from "components/Tables/ContentParsleyVideoViews/ContentParsleyVideoViews";
import ContentInstagramVideoViews from "components/Tables/ContentInstagramVideoViews/ContentInstagramVideoViews";
import ContentFacebookVideoViews from "components/Tables/ContentFacebookVideoViews/ContentFacebookVideoViews";
import ContentSnapChatVideoViews from "components/Tables/ContentSnapChatVideoViews/ContentSnapChatVideoViews";
import Top50Videos from "components/Tables/Top50Videos/Top50Videos";
import VideoOnSite from "components/Tables/VideoOnSite/VideoOnSite";
import ViewsBySpeakingId from "components/Tables/ViewsBySpeakingId/ViewsBySpeakingId";

// Insights Feeds
import InsightLatest from "components/InsightsLatest/InsightLatest";
import InsightsLatestList from "components/InsightsLatest/InsightsLatestList";

// Ads
import AdsTop5 from "components/Tables/Ads/AdsTop5";
import AdsAll from "components/Tables/Ads/AdsAll";
import AdsByTag from "components/Tables/Ads/AdsByTag";

// SnapChat
import SnapChatAggregatedSummary from "components/SnapChat/SnapChatSummary/SnapChatAggregatedSummary";
import SnapChatSummary from "components/SnapChat/SnapChatSummary/SnapChatSummary";
import {
  DemographicsPieChart,
  DemographicsBarChart,
} from "components/SnapChat/Graphs/Demographics";
import SnapChatSubscribers from "components/SnapChat/Graphs/SnapChatSubscribers";
import SnapChatShares from "components/SnapChat/Graphs/SnapChatShares";
import SnapChatScreenshots from "components/SnapChat/Graphs/SnapChatScreenshots";
import SnapChatTopsnaps from "components/SnapChat/Graphs/SnapChatTopsnaps";
import SnapChatBarLineChart from "components/SnapChat/Graphs/SnapChatBarLineChart";
import TopSeriesByUniqueViews from "components/SnapChat/Graphs/TopSeriesByUniqueViews";
import TopSeriesByUniqueViewers from "components/SnapChat/Graphs/TopSeriesByUniqueViewers";
import SnapChatMultilineChart from "components/SnapChat/Graphs/SnapChatMultilineChart";
import AvgAggregateStoryViews from "components/SnapChat/Graphs/AvgAggregateStoryViews";
import AvgAggregateTimeSpent from "components/SnapChat/Graphs/AvgAggregateTimeSpent";
import AvgAggregateActivity from "components/SnapChat/Graphs/AvgAggregateActivity";
import SnapChatComparison from "components/SnapChat/Graphs/SnapChatComparison";
import SnapChatTopStories from "components/SnapChat/Tables/SnapChatTopStories";

// Social Boards
import SocialPerformance from "components/SocialBoards/SocialPerformance";
import SocialKeyStats from "components/SocialBoards/SocialKeyStats";
import SocialPieChart from "components/SocialBoards/SocialPieChart";

import TwitterKeyStats from "components/SocialBoards/Twitter/TwitterKeyStats";
import TwitterTweetMetrics from "components/SocialBoards/Twitter/TwitterTweetMetrics";
import TwitterVideoKeyStats from "components/SocialBoards/Twitter/TwitterVideoKeyStats";
import TwitterTop5Posts from "components/SocialBoards/Twitter/TwitterTop5Posts";
import TwitterTop5PostsPer1000 from "components/SocialBoards/Twitter/TwitterTop5PostsPer1000";

import FacebookKeyStats from "components/SocialBoards/Facebook/FacebookKeyStats";
import FacebookPostMetrics from "components/SocialBoards/Facebook/FacebookPostMetrics";
import FacebookVideoKeyStats from "components/SocialBoards/Facebook/FacebookVideoKeyStats";
import FacebookTop5Posts from "components/SocialBoards/Facebook/FacebookTop5Posts";
import FacebookTop5PostsPer1000 from "components/SocialBoards/Facebook/FacebookTop5PostsPer1000";
import SocialPostBenchmark from "components/SocialBoards/SocialPostBenchmark";
import SocialTopPerformingPosts from "components/SocialBoards/SocialTopPerformingPosts";

import YoutubeKeyStats from "components/SocialBoards/Youtube/YoutubeKeyStats";
import YoutubeKeyStatsRevenue from "components/SocialBoards/Youtube/YoutubeKeyStatsRevenue";
import YoutubeDemographics from "components/SocialBoards/Youtube/YoutubeDemographics";
import YoutubeWhen from "components/SocialBoards/Youtube/YoutubeWhen";
import YoutubeWhere from "components/SocialBoards/Youtube/YoutubeWhere";
import YoutubeTop5Posts from "components/SocialBoards/Youtube/YoutubeTop5Posts";
import YoutubeTop5PostsPer1000 from "components/SocialBoards/Youtube/YoutubeTop5PostsPer1000";

import YouTubeTopVideos from "components/SocialBoards/Youtube/YouTubeTopVideos";

import InstagramKeyStats from "components/SocialBoards/Instagram/InstagramKeyStats";
import InstagramDemographics from "components/SocialBoards/Instagram/InstagramDemographics";
import InstagramWhere from "components/SocialBoards/Instagram/InstagramWhere";
import InstagramPostMetrics from "components/SocialBoards/Instagram/InstagramPostMetrics";
import InstagramVideoKeyStats from "components/SocialBoards/Instagram/InstagramVideoKeyStats";
import InstagramMediaMetrics from "components/SocialBoards/Instagram/InstagramMediaMetrics";

import InstagramTopStories from "components/Instagram/InstagramTopStories";
// Telemundo Campaign Pacing
import PrimeSeriesSocialSummary from "components/PrimeSeriesSocial/PrimeSeriesSocialSummary";
import PrimeSeriesSocialBarChartLegendsStacked from "components/PrimeSeriesSocial/PrimeSeriesSocialBarChartLegendsStacked";
import PrimeSeriesSocialHighlights from "components/PrimeSeriesSocial/PrimeSeriesSocialHighlights";
import PrimeSeriesSocialTopContent from "components/PrimeSeriesSocial/PrimeSeriesSocialTopContent";
import PrimeSeriesSocialHashtagsSummary from "components/PrimeSeriesSocial/PrimeSeriesSocialHashtagsSummary";

import YouTubeReview from "components/Tables/YouTubeReview/YouTubeReview";
import YouTubeSkyReview from "components/Tables/YouTubeSkyReview/YouTubeSkyReview";
import TwitterReview from "components/Tables/TwitterReview/TwitterReview";

import FacebookReview from "components/Tables/FacebookReview/FacebookReview";

// Nexstar
// import NexstarSummary from "components/_DEPRECATED/Nexstar/NexstarSummary";
// import NexstarVideoSummary from "components/_DEPRECATED/Nexstar/NexstarVideoSummary";
// import VideoTable from "components/_DEPRECATED/Nexstar/VideoTable";
// import NexstarStackedBarLinesImpressionsRevenue from "components/_DEPRECATED/Nexstar/NexstarStackedBarLinesImpressionsRevenue";
// import NexstarStackedBarLinesRevenueCpm from "components/_DEPRECATED/Nexstar/NexstarStackedBarLinesRevenueCpm";
// import NexstarVideoPerformance from "components/_DEPRECATED/Nexstar/NexstarVideoPerformance";
// import NexstarTableRevenue from "components/_DEPRECATED/Nexstar/NexstarTableRevenue";
// import NexstarGoals from "components/_DEPRECATED/Nexstar/NexstarGoals";
// import NexstarAdBoardSummary from "components/_DEPRECATED/Nexstar/NexstarAdBoardSummary";
// import NexstarAdBoardVideoPerformance from "components/_DEPRECATED/Nexstar/NexstarAdBoardVideoPerformance";

import MarqueeTVWatchingSummaryLive from "components/MarqueeTV/MarqueeTVWatchingSummaryLive";
import MarqueeTVWatchingSummary from "components/MarqueeTV/MarqueeTVWatchingSummary";
import MarqueeTVViewershipSummary from "components/MarqueeTV/MarqueeTVViewershipSummary";
import MarqueeTVWhere from "components/MarqueeTV/MarqueeTVWhere";
import MarqueeTVTopContent from "components/MarqueeTV/MarqueeTVTopContent";
import MarqueeViewersViewTime from "components/MarqueeTV/MarqueeViewersViewTime";
import MarqueeFreeTrialStarts from "components/MarqueeTV/MarqueeFreeTrialStarts";
import MarqueeCountries from "components/MarqueeTV/MarqueeCountries";
import MarqueeTVKPIs from "components/MarqueeTV/MarqueeTVKPIs";
import MarqueeTVads from "components/MarqueeTV/MarqueeTVads";
import MarqueeTVDataByMonth from "components/MarqueeTV/MarqueeTVDataByMonth";
import MarqueeRenewalMetrics from "components/MarqueeTV/MarqueeRenewalMetrics";
import ChurnPayingSubs from "components/MarqueeTV/ChurnPayingSubs";
import ChurnPayingSubsSummary from "components/MarqueeTV/ChurnPayingSubsSummary";
import FreeTrialEnders from "components/MarqueeTV/FreeTrialEnders";

import DualAxisStackedBarLines from "components/DualAxisStackedBarLines/DualAxisStackedBarLines";

import ConnectorsMetrics from "components/Pickaxe/ConnectorsMetrics";

import PocketWatchVideoAdRevenue from "components/PocketWatch/PocketWatchVideoAdRevenue";
import PocketWatchRevenueVsCPM from "components/PocketWatch/PocketWatchRevenueVsCPM";
import PocketWatchTableRevenue from "components/PocketWatch/PocketWatchTableRevenue";
import PocketWatchVideoPerformance from "components/PocketWatch/PocketWatchVideoPerformance";
import PocketWatchStackedBarLinesRevenueCpm from "components/PocketWatch/PocketWatchStackedBarLinesRevenueCpm";
import PocketWatchStackedBarLinesImpRevenue from "components/PocketWatch/PocketWatchStackedBarLinesImpRevenue";
import PocketWatchGoals from "components/PocketWatch/PocketWatchGoals";
import PocketWatchVideoTable from "components/PocketWatch/PocketWatchVideoTable";
import PocketWatchOperators from "components/PocketWatch/PocketWatchOperators";
import PocketWatchTopCreators from "components/PocketWatch/PocketWatchTopCreators";
import PocketWatchRecentViewing from "components/PocketWatch/PocketWatchRecentViewing";
import PocketWatchHoursViewingWeeklySummary from "components/PocketWatch/PocketWatchHoursViewingWeeklySummary";

import LeeChurn from "components/Lee/LeeChurn";
import LeeSubscriberLocations from "components/Lee/LeeSubscriberLocations";
import LeeSessionsBuckets from "components/Lee/LeeSessionsBuckets";
import LeeTotalStarts from "components/Lee/LeeTotalStarts";
import LeeSubscribersSummary from "components/Lee/LeeSubscribersSummary";
import LeeTableSubscribersChurn from "components/Lee/LeeTableSubscribersChurn";
import LeeUpcomingRenewalStats from "components/Lee/LeeUpcomingRenewalStats";
import LeeSubscriptionsUpForRenewalEngagementStatus from "components/Lee/LeeSubscriptionsUpForRenewalEngagementStatus";
import LeePriceChangeReport from "components/Lee/LeePriceChangeReport";
import LeeTVAdCampaign from "components/Lee/LeeTVAdCampaign";
import LeeFirstOfferConversion from "components/Lee/LeeFirstOfferConversion";
import LastWeeksSummary from "components/Lee/LastWeeksSummary";
import LeeSubscribersStore from "components/Lee/LeeSubscribersStore";
import LeeMetrics from "components/Lee/LeeMetrics";
import LeeSubscriptionsPieChart from "components/Lee/LeeSubscriptionsPieChart";
import LeeDualAxisStackedBarLines from "components/Lee/LeeDualAxisStackedBarLines";
import LeeActivations from "components/Lee/LeeActivations";
import LeeFY2023 from "components/Lee/LeeFY2023";
import LeeBreakoutSummary from "components/Lee/LeeBreakoutSummary";
import LeeSubscriptionsByMarket from "components/Lee/LeeSubscriptionsByMarket";
import LeeSummaryMetrics from "components/Lee/LeeSummaryMetrics";
import LeeNewsletterSummaryMetrics from "components/Lee/LeeNewsletterSummaryMetrics";
import LeeAtAGlance from "components/Lee/LeeAtAGlance";
import LeeDailyTrendCampaign from "components/Lee/LeeDailyTrendCampaign";
import LeeDailyTrendCampaignStackedBars from "components/Lee/LeeDailyTrendCampaignStackedBars";

import LeeCustomerIoCampaign from "components/Lee/LeeCustomerIoCampaign";
import LeeWeeklyRateStratification from "components/Lee/LeeWeeklyRateStratification";
import LeeRetentionBurnDown from "components/Lee/LeeRetentionBurnDown";
import LeeEngagementByPriceBucket from "components/Lee/LeeEngagementByPriceBucket";

import WorldCupMatchesYesterday from "components/WorldCup/WorldCupMatchesYesterday";
import WorldCupOfficialRatings from "components/WorldCup/WorldCupOfficialRatings";
import WorldCupOverallProgress from "components/WorldCup/WorldCupOverallProgress";
// import WorldCupTotalsYesterday from "components/WorldCup/WorldCupTotalsYesterday";
import WorldCupDailyLineCharts from "components/WorldCup/WorldCupDailyLineCharts";
import WorldCupBarChartProgress from "components/WorldCup/WorldCupBarChartProgress";
import WorldCupTournamentAverages from "components/WorldCup/WorldCupTournamentAverages";
import WorldCupYesterdaysSummary from "components/WorldCup/WorldCupYesterdaysSummary";
import WorldCupActualRatings from "components/WorldCup/WorldCupActualRatings";
import WorldCupMatchesActuals from "components/WorldCup/WorldCupMatchesActuals";
import WorldCupTournamentToDate from "components/WorldCup/WorldCupTournamentToDate";
import WorldCupSocialSummary from "components/WorldCup/WorldCupSocialSummary";
import WorldCupPlatformBreakouts from "components/WorldCup/WorldCupPlatformBreakouts";
import WorldCupStreamingPerformance from "components/WorldCup/WorldCupStreamingPerformance";
import WorldCupTables from "./WorldCup/WorldCupTables";
import WorldCupMatchesEstimates from "components/WorldCup/WorldCupMatchesEstimates";
import WorldCupMetricSummary from "components/WorldCup/WorldCupMetricSummary";
import WorldCupHashtagsSummary from "components/WorldCup/WorldCupHashtagsSummary";
import WorldCupMatchDataTiming from "components/WorldCup/WorldCupMatchDataTiming";
import WorldCupInstagramTopStories from "components/WorldCup/WorldCupInstagramTopStories";
import WorldCupMatchStats from "components/WorldCup/WorldCupMatchStats";
import WorldCupDualAxisBarChartPhases from "components/WorldCup/WorldCupDualAxisBarChartPhases";
import WorldCupStackedBar from "./WorldCup/WorldCupStackedBar";

import AreaChartLines from "components/Graphs/AreaCharts/AreaChartLines";

// Hearst
import HearstSummary from "components/Hearst/HearstSummary";
import HearstMap from "components/Hearst/HearstMap";
import HearstImpressionsDayTime from "components/Hearst/HearstImpressionsDayTime";
import HearstDisplayImpressions from "components/Hearst/HearstDisplayImpressions";
import HearstTactics from "components/Hearst/HearstTactics";
import HearstPublishers from "components/Hearst/HearstPublishers";
import HearstTrendingDisplayImpressions from "components/Hearst/HearstTrendingDisplayImpressions";
import HearstDisplayImpressionsCampaign from "components/Hearst/HearstDisplayImpressionsCampaign";
import HearstImpressionsCampaign from "components/Hearst/HearstImpressionsCampaign";
import HearstTopContent from "components/Hearst/HearstTopContent";
import HearstCompletionRateTrending from "components/Hearst/HearstCompletionRateTrending";

// Hearst Filtered
import HearstFilteredSummary from "components/Hearst/HearstFilteredSummary";
import HearstVideoImpressionsLineChart from "components/Hearst/HearstVideoImpressionsLineChart";
import HearstTopTactics from "components/Hearst/HearstTopTactics";
import HearstTopCreatives from "components/Hearst/HearstTopCreatives";
import HearstDeviceScreen from "components/Hearst/HearstDeviceScreen";
import HearstDeviceName from "components/Hearst/HearstDeviceName";

// Hearst Advertiser
import HearstAdvertiserSummary from "components/Hearst/HearstAdvertiserSummary";
import HearstTrendByImpressionType from "components/Hearst/HearstTrendByImpressionType";

// MIX
import MMMChannelAnalysisWidget from "./../pages/mix/MMMChannelAnalysisWidget";
import MixAccuracy from "components/MixAccuracy/MixAccuracy";

// YES
import YesDTCConversions from "components/Yes/YesDTCConversions";
import YESDTCConversionsBySubscriptionStatus from "./Yes/YESDTCConversionsBySubscriptionStatus";

// Gotham
import SummaryPerformance from "components/Summary/SummaryPerformance";
import Comparison from "components/Graphs/MixedGraphs/Comparison/Comparison";
import GothamDualAxis from "components/Gotham/DualAxis";
import GothamPurchasesCPA from "components/Gotham/GothamPurchasesCPA";
import GothamROAS from "components/Gotham/GothamROAS";

import { MissingWidget } from "components/Utils/Utils";

export const component = (name) => {
  switch (name) {
    case "LinesChart":
      return LinesChart;

    case "LinesChartTime":
      return LinesChartTime;

    case "PageHeader":
      return PageHeader;
    case "PageDivider":
      return PageDivider;

    case "BarChartLegendsStacked":
      return BarChartLegendsStacked;
    case "BarChartLegendsStackedNewFollowers":
      return BarChartLegendsStackedNewFollowers;
    case "BarChartLegendsStackedBoardReport":
      return BarChartLegendsStackedBoardReport;
    case "BarChartLegendsStackedYourBiz":
      return BarChartLegendsStackedYourBiz;
    case "BarChartLegends":
      return BarChartLegends;
    case "BarChartLegendsMetric":
      return BarChartLegendsMetric;
    case "CostBudget":
      return CostBudget;

    //AdBoard
    case "AdsSummary":
      return AdsSummary;
    case "AdsCostSummary":
      return AdsCostSummary;

    case "AdsCoreMetrics":
      return AdsCoreMetrics;
    case "AdsFunnelByNetwork":
      return AdsFunnelByNetwork;
    case "AdsPlatforms":
      return AdsPlatforms;
    case "AdsTableCreatives":
      return AdsTableCreatives;

    case "AdsDataByNetwork":
      return AdsDataByNetwork;
    case "AdsDataByMonth":
      return AdsDataByMonth;
    case "AdCampaign":
      return AdCampaign;

    case "ViewsYesterday":
      return ViewsYesterday;
    case "MinutesWatchedYesterday":
      return MinutesWatchedYesterday;
    case "SummaryChannel":
      return SummaryChannel;
    case "SummaryChannelByTypeBreakouts":
      return SummaryChannelByTypeBreakouts;

    case "PostsSummary":
      return PostsSummary;
    case "VideoSummary":
      return VideoSummary;
    case "SocialSummary":
      return SocialSummary;

    case "ViewsYesterdayDreamworks":
      return ViewsYesterdayDreamworks;
    case "MinutesWatchedYesterdayDreamworks":
      return MinutesWatchedYesterdayDreamworks;

    case "MostWatched":
      return MostWatched;
    case "MostShared":
      return MostShared;
    case "SocialTopPosts":
      return SocialTopPosts;
    case "Top5Posts":
      return Top5Posts;
    case "Top5PostsPer1000":
      return Top5PostsPer1000;

    case "VideoIntelligence":
      return VideoIntelligence;

    case "ViewsComparison":
      return ViewsComparison;
    case "GothamDualAxis":
      return GothamDualAxis;
    case "GothamPurchasesCPA":
      return GothamPurchasesCPA;
    case "GothamROAS":
      return GothamROAS;

    case "YouTube":
      return YouTube;
    case "SnapChat":
      return SnapChat;
    case "Facebook":
      return Facebook;
    case "Instagram":
      return Instagram;
    case "Twitter":
      return Twitter;

    case "ContentVelocity":
      return ContentVelocity;

    case "SocialFollowersSubscribers":
      return SocialFollowersSubscribers;
    case "FollowersSubscribersBreakdown":
      return FollowersSubscribersBreakdown;

    case "VideoViewsByNetwork":
      return VideoViewsByNetwork;

    case "Visitors":
      return Visitors;
    case "VisitorsByMonth":
      return VisitorsByMonth;

    case "Heatmap":
      return Heatmap;

    case "PageEngagement":
      return PageEngagement;
    case "WhereTheyViewed":
      return WhereTheyViewed;

    case "SocialGoalsFacebookTwitter":
      return SocialGoalsFacebookTwitter;
    case "SocialGoalsInstagramYouTube":
      return SocialGoalsInstagramYouTube;
    case "SocialGoalsInstagramVimeo":
      return SocialGoalsInstagramVimeo;
    case "SocialGoalsInstagramVimeoYouTube":
      return SocialGoalsInstagramVimeoYouTube;
    case "SocialGoalsFacebookTwitterInstagram":
      return SocialGoalsFacebookTwitterInstagram;

    case "Widget":
      return Widget;
    case "Element":
      return Element;

    case "PageViews":
      return PageViews;

    case "VisitsBySource":
      return VisitsBySource;
    case "TopReferrers":
      return TopReferrers;
    case "TopPostsThisHour":
      return TopPostsThisHour;
    case "TopPostsToday":
      return TopPostsToday;

    case "NewReturning":
      return NewReturning;
    case "ReturnFrequency":
      return ReturnFrequency;
    case "Donations":
      return Donations;
    case "ConversionFunnel":
      return ConversionFunnel;

    case "EmailSummary":
      return EmailSummary;
    case "EmailPerformance":
      return EmailPerformance;

    case "NewsletterRecent":
      return NewsletterRecent;
    case "NewslettersTopLinks":
      return NewslettersTopLinks;

    case "FollowersByBrand":
      return FollowersByBrand;

    case "TopContent":
      return TopContent;

    case "TopMovies":
      return TopMovies;

    case "Top20Content":
      return Top20Content;

    case "TopContentSeasonEpisode":
      return TopContentSeasonEpisode;

    case "ContentTopPages":
      return ContentTopPages;
    case "ContentYouTubeVideoViews":
      return ContentYouTubeVideoViews;
    case "ContentVimeoVideoViews":
      return ContentVimeoVideoViews;
    case "ContentParsleyVideoViews":
      return ContentParsleyVideoViews;
    case "ContentInstagramVideoViews":
      return ContentInstagramVideoViews;
    case "ContentFacebookVideoViews":
      return ContentFacebookVideoViews;
    case "ContentSnapChatVideoViews":
      return ContentSnapChatVideoViews;
    case "Top50Videos":
      return Top50Videos;
    case "VideoOnSite":
      return VideoOnSite;
    case "ViewsBySpeakingId":
      return ViewsBySpeakingId;

    case "InsightLatest":
      return InsightLatest;
    case "InsightsLatestList":
      return InsightsLatestList;

    case "QueryBuilder":
      return QueryBuilder;

    case "InsightArchive":
      return InsightArchive;
    case "InsightsArchiveList":
      return InsightsArchiveList;
    case "KeyFindings":
      return KeyFindings;

    case "ViewersLineGraphs":
      return ViewersLineGraphs;

    case "AdsTop5":
      return AdsTop5;

    case "AdsByTag":
      return AdsByTag;

    case "AdsAll":
      return AdsAll;

    // BritBox
    case "SummaryFreeTrials":
      return SummaryFreeTrials;

    case "SummaryPaidSubs":
      return SummaryPaidSubs;

    case "Views":
      return Views;

    case "Financial":
      return Financial;

    case "SubscribersSummary":
      return SubscribersSummary;

    case "FreeTrialConversion":
      return FreeTrialConversion;

    case "FreeTrialConversionPrediction":
      return FreeTrialConversionPrediction;

    case "SubscriberRenewalCancel":
      return SubscriberRenewalCancel;

    case "AuditSummary":
      return AuditSummary;

    // case "AuditOverview":
    //   return AuditOverview;

    case "AuditBoard":
      return AuditBoard;

    case "SeasonViewingCompletion":
      return SeasonViewingCompletion;

    case "AttributionSummary":
      return AttributionSummary;

    case "AttributionEfficiency":
      return AttributionEfficiency;

    // case "SubscribersSummary":
    //   return SubscribersSummary

    // case "SubscriberRenewalCancel":
    //   return SubscriberRenewalCancel

    case "FreeTrialStarts":
      return FreeTrialStarts;

    // TODO: delete - pending migration to new dashboard
    case "DailyActives":
      return DailyActives;

    case "DailyActivesLive":
      return DailyActivesLive;

    case "DailyActivesLiveYourBiz":
      return DailyActivesLiveYourBiz;

    case "SubscriberMakeup":
      return SubscriberMakeup;

    // TODO: delete - pending migration to new dashboard
    case "WatchingSummary":
      return WatchingSummary;

    case "WatchingSummaryLive":
      return WatchingSummaryLive;

    case "LastWeekSummary":
      return LastWeekSummary;

    case "LastWeekViewing":
      return LastWeekViewing;

    case "NewSubsByPlatform":
      return NewSubsByPlatform;

    case "PieChartLegends":
      return PieChartLegends;

    case "SocialCountsByBrand":
      return SocialCountsByBrand;

    case "BillingSummary":
      return BillingSummary;

    case "TopLTVCPA":
      return TopLTVCPA;

    case "SnapChatAggregatedSummary":
      return SnapChatAggregatedSummary;
    case "SnapChatSummary":
      return SnapChatSummary;
    case "DemographicsPieChart":
      return DemographicsPieChart;
    case "DemographicsBarChart":
      return DemographicsBarChart;
    case "SnapChatSubscribers":
      return SnapChatSubscribers;
    case "SnapChatShares":
      return SnapChatShares;
    case "SnapChatScreenshots":
      return SnapChatScreenshots;
    case "SnapChatTopsnaps":
      return SnapChatTopsnaps;
    case "SnapChatBarLineChart":
      return SnapChatBarLineChart;
    case "TopSeriesByUniqueViews":
      return TopSeriesByUniqueViews;
    case "TopSeriesByUniqueViewers":
      return TopSeriesByUniqueViewers;
    case "SnapChatMultilineChart":
      return SnapChatMultilineChart;
    case "AvgAggregateStoryViews":
      return AvgAggregateStoryViews;
    case "AvgAggregateTimeSpent":
      return AvgAggregateTimeSpent;
    case "AvgAggregateActivity":
      return AvgAggregateActivity;
    case "SnapChatComparison":
      return SnapChatComparison;
    case "SnapChatTopStories":
      return SnapChatTopStories;

    // Social Boards
    case "TwitterKeyStats":
      return TwitterKeyStats;
    case "TwitterTweetMetrics":
      return TwitterTweetMetrics;
    case "TwitterVideoKeyStats":
      return TwitterVideoKeyStats;
    case "TwitterTop5Posts":
      return TwitterTop5Posts;
    case "TwitterTop5PostsPer1000":
      return TwitterTop5PostsPer1000;

    case "FacebookKeyStats":
      return FacebookKeyStats;
    case "FacebookPostMetrics":
      return FacebookPostMetrics;
    case "FacebookVideoKeyStats":
      return FacebookVideoKeyStats;
    case "FacebookTop5Posts":
      return FacebookTop5Posts;
    case "FacebookTop5PostsPer1000":
      return FacebookTop5PostsPer1000;
    case "SocialPostBenchmark":
      return SocialPostBenchmark;
    case "SocialTopPerformingPosts":
      return SocialTopPerformingPosts;

    case "YoutubeKeyStats":
      return YoutubeKeyStats;
    case "YoutubeKeyStatsRevenue":
      return YoutubeKeyStatsRevenue;
    case "YoutubeDemographics":
      return YoutubeDemographics;
    case "YoutubeWhen":
      return YoutubeWhen;
    case "YoutubeWhere":
      return YoutubeWhere;
    case "YoutubeTop5Posts":
      return YoutubeTop5Posts;
    case "YoutubeTop5PostsPer1000":
      return YoutubeTop5PostsPer1000;
    case "YouTubeTopVideos":
      return YouTubeTopVideos;

    case "InstagramKeyStats":
      return InstagramKeyStats;
    case "InstagramDemographics":
      return InstagramDemographics;
    case "InstagramWhere":
      return InstagramWhere;
    case "InstagramPostMetrics":
      return InstagramPostMetrics;
    case "InstagramVideoKeyStats":
      return InstagramVideoKeyStats;
    case "InstagramMediaMetrics":
      return InstagramMediaMetrics;

    case "SocialPerformance":
      return SocialPerformance;
    case "SocialKeyStats":
      return SocialKeyStats;
    case "SocialPieChart":
      return SocialPieChart;
    case "SeasonReleasePopularity":
      return SeasonReleasePopularity;

    case "PrimeSeriesSocialSummary":
      return PrimeSeriesSocialSummary;
    case "PrimeSeriesSocialBarChartLegendsStacked":
      return PrimeSeriesSocialBarChartLegendsStacked;
    case "PrimeSeriesSocialHighlights":
      return PrimeSeriesSocialHighlights;
    case "PrimeSeriesSocialTopContent":
      return PrimeSeriesSocialTopContent;
    case "PrimeSeriesSocialHashtagsSummary":
      return PrimeSeriesSocialHashtagsSummary;

    // Instagram
    case "InstagramTopStories":
      return InstagramTopStories;

    //Donations
    case "DonationsByLongetivity":
      return DonationsByLongetivity;
    case "DonationsBarChart":
      return DonationsBarChart;
    case "DonationsBySource":
      return DonationsBySource;
    case "DonationsSummary":
      return DonationsSummary;
    case "DonationsVisits":
      return DonationsVisits;
    case "DonationsBarLineChart":
      return DonationsBarLineChart;
    case "DonationsLineChart":
      return DonationsLineChart;
    case "DonationsTableSource":
      return DonationsTableSource;
    case "YouTubeReview":
      return YouTubeReview;
    case "YouTubeSkyReview":
      return YouTubeSkyReview;
    case "TwitterReview":
      return TwitterReview;
    case "FacebookReview":
      return FacebookReview;

    // case "NexstarVideoSummary":
    //   return NexstarVideoSummary;
    // case "NexstarSummary":
    //   return NexstarSummary;
    // case "NexstarStackedBarLinesImpressionsRevenue":
    //   return NexstarStackedBarLinesImpressionsRevenue;
    // case "NexstarStackedBarLinesRevenueCpm":
    //   return NexstarStackedBarLinesRevenueCpm;
    // case "NexstarVideoPerformance":
    //   return NexstarVideoPerformance;
    // case "NexstarGoals":
    //   return NexstarGoals;
    // case "NexstarAdBoardSummary":
    //   return NexstarAdBoardSummary;
    // case "NexstarTableRevenue":
    //   return NexstarTableRevenue;
    // case "NexstarAdBoardVideoPerformance":
    //   return NexstarAdBoardVideoPerformance;

    case "PocketWatchVideoAdRevenue":
      return PocketWatchVideoAdRevenue;
    case "PocketWatchRevenueVsCPM":
      return PocketWatchRevenueVsCPM;
    case "PocketWatchVideoPerformance":
      return PocketWatchVideoPerformance;
    case "PocketWatchTableRevenue":
      return PocketWatchTableRevenue;
    case "PocketWatchStackedBarLinesRevenueCpm":
      return PocketWatchStackedBarLinesRevenueCpm;
    case "PocketWatchStackedBarLinesImpRevenue":
      return PocketWatchStackedBarLinesImpRevenue;
    case "PocketWatchGoals":
      return PocketWatchGoals;
    case "PocketWatchVideoTable":
      return PocketWatchVideoTable;
    case "PocketWatchOperators":
      return PocketWatchOperators;
    case "PocketWatchTopCreators":
      return PocketWatchTopCreators;
    case "PocketWatchRecentViewing":
      return PocketWatchRecentViewing;
    case "PocketWatchHoursViewingWeeklySummary":
      return PocketWatchHoursViewingWeeklySummary;

    case "MarqueeTVWatchingSummaryLive":
      return MarqueeTVWatchingSummaryLive;
    case "MarqueeTVWatchingSummary":
      return MarqueeTVWatchingSummary;
    case "MarqueeTVViewershipSummary":
      return MarqueeTVViewershipSummary;
    case "MarqueeTVWhere":
      return MarqueeTVWhere;
    case "MarqueeTVTopContent":
      return MarqueeTVTopContent;
    case "MarqueeViewersViewTime":
      return MarqueeViewersViewTime;
    case "MarqueeFreeTrialStarts":
      return MarqueeFreeTrialStarts;
    case "MarqueeCountries":
      return MarqueeCountries;
    case "MarqueeTVKPIs":
      return MarqueeTVKPIs;
    case "MarqueeTVads":
      return MarqueeTVads;
    case "MarqueeTVDataByMonth":
      return MarqueeTVDataByMonth;

    case "MarqueeRenewalMetrics":
      return MarqueeRenewalMetrics;

    case "DualAxisStackedBarLines":
      return DualAxisStackedBarLines;
    case "ChurnPayingSubs":
      return ChurnPayingSubs;
    case "ChurnPayingSubsSummary":
      return ChurnPayingSubsSummary;
    case "FreeTrialEnders":
      return FreeTrialEnders;
    case "ConnectorsMetrics":
      return ConnectorsMetrics;

    case "LeeSessionsBuckets":
      return LeeSessionsBuckets;

    case "LeeChurn":
      return LeeChurn;
    case "LeeSubscriberLocations":
      return LeeSubscriberLocations;
    case "LeeTotalStarts":
      return LeeTotalStarts;
    case "LeeSubscribersSummary":
      return LeeSubscribersSummary;
    case "LeeTableSubscribersChurn":
      return LeeTableSubscribersChurn;
    case "LeeUpcomingRenewalStats":
      return LeeUpcomingRenewalStats;
    case "LeeSubscriptionsUpForRenewalEngagementStatus":
      return LeeSubscriptionsUpForRenewalEngagementStatus;
    case "LeePriceChangeReport":
      return LeePriceChangeReport;
    case "LeeTVAdCampaign":
      return LeeTVAdCampaign;
    case "LeeFirstOfferConversion":
      return LeeFirstOfferConversion;
    case "LastWeeksSummary":
      return LastWeeksSummary;
    case "LeeSubscribersStore":
      return LeeSubscribersStore;
    case "LeeMetrics":
      return LeeMetrics;
    case "LeeSubscriptionsPieChart":
      return LeeSubscriptionsPieChart;
    case "LeeDualAxisStackedBarLines":
      return LeeDualAxisStackedBarLines;
    case "LeeActivations":
      return LeeActivations;
    case "LeeFY2023":
      return LeeFY2023;
    case "LeeBreakoutSummary":
      return LeeBreakoutSummary;
    case "LeeSubscriptionsByMarket":
      return LeeSubscriptionsByMarket;
    case "LeeSummaryMetrics":
      return LeeSummaryMetrics;
    case "LeeNewsletterSummaryMetrics":
      return LeeNewsletterSummaryMetrics;
    case "LeeAtAGlance":
      return LeeAtAGlance;
    case "LeeDailyTrendCampaign":
      return LeeDailyTrendCampaign;
    case "LeeDailyTrendCampaignStackedBars":
      return LeeDailyTrendCampaignStackedBars;
    case "LeeCustomerIoCampaign":
      return LeeCustomerIoCampaign;
    case "LeeWeeklyRateStratification":
      return LeeWeeklyRateStratification;
    case "LeeRetentionBurnDown":
      return LeeRetentionBurnDown;
    case "LeeEngagementByPriceBucket":
      return LeeEngagementByPriceBucket;

    case "WorldCupMatchesYesterday":
      return WorldCupMatchesYesterday;
    case "WorldCupOfficialRatings":
      return WorldCupOfficialRatings;
    case "WorldCupOverallProgress":
      return WorldCupOverallProgress;
    // case "WorldCupTotalsYesterday":
    //   return WorldCupTotalsYesterday;
    case "WorldCupDailyLineCharts":
      return WorldCupDailyLineCharts;
    case "WorldCupBarChartProgress":
      return WorldCupBarChartProgress;
    case "WorldCupTournamentAverages":
      return WorldCupTournamentAverages;
    case "WorldCupYesterdaysSummary":
      return WorldCupYesterdaysSummary;
    case "WorldCupActualRatings":
      return WorldCupActualRatings;
    case "WorldCupMatchesActuals":
      return WorldCupMatchesActuals;
    case "WorldCupTournamentToDate":
      return WorldCupTournamentToDate;
    case "WorldCupSocialSummary":
      return WorldCupSocialSummary;
    case "WorldCupPlatformBreakouts":
      return WorldCupPlatformBreakouts;
    case "WorldCupStreamingPerformance":
      return WorldCupStreamingPerformance;
    case "WorldCupTables":
      return WorldCupTables;
    case "WorldCupMatchesEstimates":
      return WorldCupMatchesEstimates;
    case "WorldCupMetricSummary":
      return WorldCupMetricSummary;
    case "WorldCupHashtagsSummary":
      return WorldCupHashtagsSummary;
    case "WorldCupMatchDataTiming":
      return WorldCupMatchDataTiming;
    case "WorldCupInstagramTopStories":
      return WorldCupInstagramTopStories;
    case "WorldCupMatchStats":
      return WorldCupMatchStats;
    case "WorldCupDualAxisBarChartPhases":
      return WorldCupDualAxisBarChartPhases;
    case "WorldCupStackedBar":
      return WorldCupStackedBar;
    case "MMMChannelAnalysis":
      return MMMChannelAnalysisWidget;

    case "YesDTCConversions":
      return YesDTCConversions;
    case "YESDTCConversionsBySubscriptionStatus":
      return YESDTCConversionsBySubscriptionStatus;

    case "AreaChartLines":
      return AreaChartLines;

    case "HearstSummary":
      return HearstSummary;
    case "HearstMap":
      return HearstMap;
    case "HearstImpressionsDayTime":
      return HearstImpressionsDayTime;
    case "HearstDisplayImpressions":
      return HearstDisplayImpressions;
    case "HearstTactics":
      return HearstTactics;

    case "HearstTrendingDisplayImpressions":
      return HearstTrendingDisplayImpressions;
    case "HearstDisplayImpressionsCampaign":
      return HearstDisplayImpressionsCampaign;
    case "HearstImpressionsCampaign":
      return HearstImpressionsCampaign;
    case "HearstPublishers":
      return HearstPublishers;
    case "HearstTopContent":
      return HearstTopContent;
    case "HearstCompletionRateTrending":
      return HearstCompletionRateTrending;

    case "HearstFilteredSummary":
      return HearstFilteredSummary;
    case "HearstVideoImpressionsLineChart":
      return HearstVideoImpressionsLineChart;
    case "HearstTopTactics":
      return HearstTopTactics;
    case "HearstTopCreatives":
      return HearstTopCreatives;
    case "HearstDeviceName":
      return HearstDeviceName;
    case "HearstDeviceScreen":
      return HearstDeviceScreen;

    case "HearstAdvertiserSummary":
      return HearstAdvertiserSummary;

    case "HearstTrendByImpressionType":
      return HearstTrendByImpressionType;
    case "SummaryPerformance":
      return SummaryPerformance;
    case "Comparison":
      return Comparison;
    case "MixAccuracy":
      return MixAccuracy;
    default:
      return MissingWidget;
  }
};
